import React from 'react';
import './Skills.css';

function SkillItems({ skillName, skillUrl }) {
  return (
    <div className="skill-card glass-card">
      <div className="skill-icon-container">
        <img src={skillUrl} alt={`${skillName} icon`} className="skill-icon" />
      </div>
      <span className="skill-name">{skillName}</span>
    </div>
  );
}

export default SkillItems;
